<template>
  <div class="month_view"  v-loading="loading">
    <div class="view_title">
      <div class="title_item" v-for="(item,index) in weekDateNameList">
        {{ item }}
      </div>
    </div>
    <div class="view_body">
      <el-calendar v-model="curDate">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template
            slot="dateCell"
            slot-scope="{date, data}">
          <div :class="data.isSelected ? 'is-selected' : ''">
            <el-popover
                ref="taskPopMonth"
                placement="right"
                width="280"
                :visible-arrow="false"
                popper-class="popover_card"
                :disabled="isShowPop(data)"
                trigger="click">
              <TaskDefaultList :taskList="monthTask[data.day]" :invoke="invoke"></TaskDefaultList>
              <div class="task_list" slot="reference">
                <div class="date_num">
                  <div class="num"
                       :class="{'num_today':isToday(data.day),'num_no_curmonth':data.type!=='current-month','num_have_newintv':new Date(spritTime(data.day))>new Date() && monthTask[data.day],'num_have_oldintv':new Date(spritTime(data.day))<new Date() && monthTask[data.day]}">
                    {{ data.day | formatdd }}
                  </div>
                </div>
                <div class="list_box">
                  <div class="list_item" v-for="(itemTask,indexTask) in monthTask[data.day]"
                       :class="{'isNotShow':indexTask>2 && monthTask[data.day].length!==4,'gray_style':!isMoreCurDate(itemTask.endTimeLong)}"
                       :title="itemTask.intvStartHourAndMinute+' '+itemTask.intvTitle">
                    {{ itemTask.intvStartHourAndMinute }} {{ itemTask.intvTitle }}
                  </div>
                  <div class="list_item_more" v-if="monthTask[data.day] && monthTask[data.day].length>4"
                       :class="{'gray_colo':!isMoreCurDate(monthTask[data.day][monthTask[data.day].length-1].endTimeLong)}"
                       :title="getLangMsg('intvTaskCale_key0002',{'text': monthTask[data.day].length - 3})">
                    {{getLangMsg('intvTaskCale_key0002',{'text': monthTask[data.day].length - 3})}}
                  </div>
                </div>

              </div>
            </el-popover>
          </div>
        </template>
      </el-calendar>
    </div>
  </div>
</template>

<script>
import {utils} from "../common/common";
import TaskDefaultList from "./TaskDefaultList.vue";

export default {
  props: {
    dateValue: String,
    invoke: Function,
    monthData: Array,
    currentDateType:String
  },
  components: {
    TaskDefaultList
  },
  watch: {
    dateValue: function (val) {
      this.curDate = new Date(val);
      if (utils.dateFormat('yyyy-MM', val) !== this.curMonthId && this.currentDateType === 'month') {
        this.getMonthData(val);
      }
    },
    currentDateType:function (val){
      if(val === 'month'){
        this.getMonthData(this.dateValue);
      }
    },
    curDate: function (val) {
      this.$emit('setDateValue', val)
    },
    monthData(val) {
      let newMonthTask = {};
      for (let i in val) {
        let date = utils.dateFormat('yyyy-MM-dd', val[i].startTimeLong);
        if (newMonthTask[date] === undefined) {
          newMonthTask[date] = [];
        }
        newMonthTask[date].push(val[i])
      }
      this.monthTask = newMonthTask;
      this.loading = false;
    }
  },
  filters: {
    formatHM(value) {
      return utils.dateFormat("hh:mm", value);
    },
    formatdd(value) {
      console.log('今',value,utils.dateFormat("yyyy-MM-dd"))
      if (utils.dateFormat("yyyy-MM-dd") == value) {
        return "今";
      } else {
        return Number(utils.dateFormat("dd", value));
      }
    },

  },
  data() {
    return {
      weekDateNameList: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      curDate: new Date(),
      curMonthId: '',
      monthTask: {},
      loading: true
    }
  },
  mounted() {
     this.weekDateNameList = [this.getLangMsg("intvTaskCale_monday"),
       this.getLangMsg("intvTaskCale_tuesday"),
       this.getLangMsg("intvTaskCale_wednesday"),
       this.getLangMsg("intvTaskCale_thursday"),
       this.getLangMsg("intvTaskCale_friday"),
       this.getLangMsg("intvTaskCale_saturday"),
       this.getLangMsg("intvTaskCale_weekday")]
  },
  methods: {
    isToday(day) {
      if (day && utils.dateFormat("yyyy-MM-dd") == day) {
        return true;
      } else {
        return false;
      }
    },
    isShowPop(data) {
      if (this.monthTask[data.day] && this.monthTask[data.day].length > 0 && data.type === 'current-month') {
        return false;
      } else {
        return true;
      }
    },
    getMonthCaleEndPoint(dateStr) {
      let yearNum = new Date(dateStr).getFullYear();
      let monthNum = new Date(dateStr).getMonth();
      let monthStartDay = new Date(yearNum, monthNum, 1);
      let startDayweekNum = monthStartDay.getDay() === 0 ? 7 : monthStartDay.getDay();
      let caleMonthStartDay = this.getZeroTime(monthStartDay.setDate(monthStartDay.getDate() + (0 - startDayweekNum + 1)));
      let caleMonthStartDayBack = new Date(caleMonthStartDay);
      let caleMonthEndDay = this.getZeroTime(caleMonthStartDayBack.setDate(caleMonthStartDayBack.getDate() + (7 * 6)));
      console.log(caleMonthStartDay, caleMonthEndDay)
      return {startTime: new Date(caleMonthStartDay).getTime(), endTime: new Date(caleMonthEndDay).getTime()}
    },
    isMoreCurDate(dateNum) {
      return new Date(dateNum) > new Date();
    },
    getMonthData(val){
      console.log('获取月数据')
      this.loading = true;
      this.invoke("getMonthData", this.getMonthCaleEndPoint(val))
      this.curMonthId = utils.dateFormat('yyyy-MM', val)
    },
    spritTime(time){
      return utils.dateFormat('yyyy/MM/dd',time);
    }

  }
}
</script>
<style lang="less">
.month_view {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;

  .view_title {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 50px;
    margin-top: -13px;

    .title_item {
      width: 20px;
      flex-grow: 1;
      font-size: 18px;
      color: #333333;
      text-align: center;
      line-height: 50px;
    }
  }

  .view_body {
    flex-grow: 1;

    .el-calendar {
      .el-calendar__header {
        display: none;
      }

      thead {
        display: none
      }

      .el-calendar__body {
        padding: 0;
        .el-calendar-table__row .is-selected{
          background-color: var(--theme-color-level1);
        }
        .el-calendar-day {
          box-sizing: border-box;
          height: 113px;
          padding: 0;

          & > div {
            height: 100%;
          }

          &:hover {
            background: none;
            border: 1px solid #5582F3;
            border: 1px solid var(--theme-color);
            margin: -1px;
          }
        }
      }
    }

    .task_list {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      height: 100%;

      .date_num {
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 6px;

        .num {
          flex-shrink: 0;
          height: 30px;
          width: 30px;
          border-radius: 50%;
          line-height: 30px;
          text-align: center;
          color: #333333;
          font-size: 16px;
        }

        .num_today {
          color: #FFFFFF !important;
          background: #5582F3 !important;
          background: var(--theme-color) !important;
        }

        .num_no_curmonth {
          color: #999999 !important;
          background: none !important;
        }

        .num_have_newintv {
          color: #FFFFFF;
          background: #FC8555;
        }

        .num_have_oldintv {
          color: #FAFAF5;
          background: #BBBBBB;
        }
      }

      .list_box {
        color: #333333;

        .list_item {
          margin-bottom: 2px;
          padding-left: 8px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          background: #FFF1D4;
          border-left: 2px solid #FF991C;
          height: 15px;
          line-height: 16px;
        }

        .list_item_more {
          color: #666666;
          margin-top: 1px;
          padding-left: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .isNotShow {
          display: none;
        }

        .dian {
          display: inline-block;
          width: 2px;
          height: 4px;
          background: #FC8555;
          margin-right: 8px;
        }

        .gray_style {
          background: #F5F5F5;
          border-left: 2px solid #BBBBBB;

        }

        .gray_bgColor {
          background: #BBBBBB;
        }
      }
    }
  }

}
</style>